import React from "react";
import DashboardLayout from "../Layout/DashboardLayout";
import Breadcrumbs from "../Components/Dashboard/Breadcrumbs";
import ProfileAvatar from "../Assets/ProfileAvatarTwo.png";
import UploadIcon from "../Assets/Icons/uploadIcon.svg";

export default function ChangePassword() {
  return (
    <DashboardLayout>
      <section className="bg-white pl-6 py-4 gap-y-5 w-full flex flex-col items-start">
        <Breadcrumbs
          links={[
            { name: "Individual Profile", link: "dsads" },
            { name: "Edit Profile", link: "asds" },
          ]}
        />
        <h1 className="text-xl font-semibold">Edit Profile</h1>
      </section>
      <section className="bg-[#f9fafb] w-full h-screen flex items-start justify-center pt-6">
        <div className="px-8">
          <div className="flex items-start justify-between">
            <div
              style={{
                boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
              }}
              className="w-full pt-4 pb-4 bg-white rounded-[8px] flex items-center gap-4 pl-6 pr-24"
            >
              <img className="w-[7rem] h-[7rem]" src={ProfileAvatar} />
              <div className="flex items-start flex-col gap-3">
                <div>
                  <p className="text-[1.3rem] text-[#111928] font-[700]">
                    Thomas Lean
                  </p>
                  <p className="text-[1rem] text-[#6B7280]">Data Scientist</p>
                </div>
                <button className="w-[8.8rem] h-[2.2rem] rounded-[8px] bg-[#942A27] text-[0.90rem] text-white flex items-center justify-center gap-1">
                  <img src={UploadIcon} /> Change picture
                </button>
              </div>
            </div>
            <div className="ml-8">
              <div
                style={{ boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.08)" }}
                className="w-full pt-6 pb-6 rounded-[8px] bg-white px-6 "
              >
                <p className="text-[1rem] text-[#111928] font-[700]">
                  Password information
                </p>
                <div className="flex items-center flex-col gap-3 mt-4">
                  <div className="flex items-start flex-col gap-1">
                    <label className="text-[0.95rem] text-[#111928] font-[500]">
                      Current password
                    </label>
                    <input
                      className="w-[34rem] h-[2.6rem] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px]"
                      type="password"
                      placeholder="••••••••••"
                    />
                  </div>
                  <div className="flex items-start flex-col gap-1">
                    <label className="text-[0.95rem] text-[#111928] font-[500]">
                      New password
                    </label>
                    <input
                      className="w-[34rem] h-[2.6rem] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px]"
                      type="password"
                      placeholder="••••••••••"
                    />
                  </div>
                  <div className="flex items-start flex-col gap-1">
                    <label className="text-[0.95rem] text-[#111928] font-[500]">
                      Confirm New password
                    </label>
                    <input
                      className="w-[34rem] h-[2.6rem] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px]"
                      type="password"
                      placeholder="••••••••••"
                    />
                  </div>
                </div>
                <div className="mt-4">
                  <button className="w-[5.8rem] h-[2.5rem] text-[0.94rem] rounded-[8px] bg-[#942A27] text-white">
                    Save All
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </DashboardLayout>
  );
}
